/** =========================================================
 * Module: utils.js
 * Utility library to use across the theme
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.utils')
    .service('Utils', Utils)
    .filter('capitalize', function () {
      return function (input) {
        return (input) ? input.capitalize() : '';
      };
    })
    .filter('replace_', function () {
      return function (input) {
        return (input) ? input._replace() : '';
      };
    })
    .filter('format_date', function ($rootScope) {
      return function (input) {
        return (input) ? moment(input).format($rootScope.appConfig.dateFormat) : '';
      };
    })
    .filter('format_date_time', function ($rootScope) {
      return function (input) {
        return (input) ? moment(input).format($rootScope.appConfig.dateTimeFormat) : '';
      };
    });

  Utils.$inject = ['$window', 'APP_MEDIAQUERY'];

  function Utils($window, APP_MEDIAQUERY) {
    var $html = angular.element('html');
    var $win = angular.element($window);
    var $body = angular.element('body');

    return {
      // DETECTION
      support: {
        transition: (function () {
          var transitionEnd = (function () {
            var element = document.body || document.documentElement;
            var transEndEventNames = {
              WebkitTransition: 'webkitTransitionEnd',
              MozTransition: 'transitionend',
              OTransition: 'oTransitionEnd otransitionend',
              transition: 'transitionend'
            };
            var name;

            for (name in transEndEventNames) {
              if (element.style[name] !== undefined) {
                return transEndEventNames[name];
              }
            }

            return null;
          }());

          return transitionEnd && {
            end: transitionEnd
          };
        })(),
        animation: (function () {
          var animationEnd = (function () {
            var element = document.body || document.documentElement;
            var animEndEventNames = {
              WebkitAnimation: 'webkitAnimationEnd',
              MozAnimation: 'animationend',
              OAnimation: 'oAnimationEnd oanimationend',
              animation: 'animationend'
            };
            var name;

            for (name in animEndEventNames) {
              if (element.style[name] !== undefined) {
                return animEndEventNames[name];
              }
            }

            return null;
          }());

          return animationEnd && {
            end: animationEnd
          };
        })(),
        requestAnimationFrame: window.requestAnimationFrame ||
                    window.webkitRequestAnimationFrame ||
                    window.mozRequestAnimationFrame ||
                    window.msRequestAnimationFrame ||
                    window.oRequestAnimationFrame ||
                    function (callback) {
                      window.setTimeout(callback, 1000 / 60);
                    },
        /* jshint -W069*/
        touch: (
          ('ontouchstart' in window && navigator.userAgent.toLowerCase().match(/mobile|tablet/)) ||
                    (window.DocumentTouch && document instanceof window.DocumentTouch) ||
                    (window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 0) || // IE 10
                    (window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 0) || // IE >=11
                    false
        ),
        mutationobserver: (window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver || null)
      },
      // UTILITIES
      isInView: function (element, options) {
        /* jshint -W106*/
        var $element = $(element);

        if (!$element.is(':visible')) {
          return false;
        }

        var window_left = $win.scrollLeft();
        var window_top = $win.scrollTop();
        var offset = $element.offset();
        var left = offset.left;
        var top = offset.top;

        var preparedOptions = $.extend({
          topoffset: 0,
          leftoffset: 0
        }, options);

        if (top + $element.height() >= window_top && top - preparedOptions.topoffset <= window_top + $win.height() &&
                    left + $element.width() >= window_left && left - preparedOptions.leftoffset <= window_left + $win.width()) {
          return true;
        }

        return false;
      },

      langdirection: $html.attr('dir') === 'rtl' ? 'right' : 'left',

      isTouch: function () {
        return $html.hasClass('touch');
      },

      isSidebarCollapsed: function () {
        return $body.hasClass('aside-collapsed') || $body.hasClass('aside-collapsed-text');
      },

      isSidebarToggled: function () {
        return $body.hasClass('aside-toggled');
      },

      isMobile: function () {
        return $win.width() < APP_MEDIAQUERY.tablet;
      }
    };
  }
})();
